import { useEffect } from 'react';

/**
 * Hook لمنع scroll الـ body عندما يكون الـ modal مفتوح
 * يضيف overflow: hidden للـ body عند فتح الـ modal
 * ويزيله عند إغلاق الـ modal
 */
export function useBodyScrollLock(isOpen: boolean) {
    useEffect(() => {
        if (isOpen) {
            // حفظ القيمة الأصلية للـ overflow
            const originalOverflow = document.body.style.overflow;
            const originalPaddingRight = document.body.style.paddingRight;

            // حساب عرض الـ scrollbar لتجنب القفزة عند إخفاء الـ scroll
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

            // منع الـ scroll وإضافة padding لتعويض عرض الـ scrollbar
            document.body.style.overflow = 'hidden';
            if (scrollbarWidth > 0) {
                document.body.style.paddingRight = `${scrollbarWidth}px`;
            }

            // إرجاع القيم الأصلية عند cleanup
            return () => {
                document.body.style.overflow = originalOverflow;
                document.body.style.paddingRight = originalPaddingRight;
            };
        }
    }, [isOpen]);
}
